// extracted by mini-css-extract-plugin
export default {"PermissioTitle":"EditRoles_PermissioTitle__N9f-5","PermissionWrapper":"EditRoles_PermissionWrapper__oJsB-","PermissionInput":"EditRoles_PermissionInput__Qa8TN"};